module.exports = __webpack_public_path__ + "images/bd-white-logo-f24d2f7a.svg";